import { Length, MaxLength, IsOptional, IsEmail, IsNumberString, MinLength } from 'class-validator';

export class UsuarioValidate {
    @Length(1, 100)
    Nombre: string;
    @MinLength(9)
    Telefono1: string;
    @IsOptional()
    @MinLength(9)
    Telefono2: string;
    @IsEmail()
    EMail: string;
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/usuarioValidate.entity.ts